export default "__VITE_PUBLIC_ASSET__af6a926f__"